import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'zop-formly-repeat',
    templateUrl: './repeat.component.html',
    styleUrl: './repeat.component.scss',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, MatButtonModule, MatIconModule],
})
export class RepeatComponent extends FieldArrayType {
    // FieldArrayType already exposes add() and remove(index)
}
